export default "__VITE_ASSET__BND0YgH7__"